import { history } from 'prosemirror-history';

export const historyPlugin = history();
